import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  isActive?: boolean;
}

const SendIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  isActive = false,
  ...props
}) => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9925 2.50833L2.49912 6.30249L5.99495 8.32583L9.07745 5.24249C9.23382 5.08624 9.44586 4.9985 9.66691 4.99858C9.88797 4.99865 10.0999 5.08654 10.2562 5.24291C10.4125 5.39928 10.5002 5.61131 10.5001 5.83237C10.5 6.05343 10.4122 6.2654 10.2558 6.42166L7.17245 9.505L9.19745 13L12.9925 2.50833ZM13.2616 0.638327C14.2575 0.277494 15.2225 1.24249 14.8616 2.23833L10.46 14.4092C10.0983 15.4075 8.73495 15.5292 8.20245 14.61L5.52162 9.97833L0.889954 7.29749C-0.0292127 6.76499 0.0924542 5.40166 1.09079 5.03999L13.2616 0.638327Z"
      fill={isActive ? 'url(#gradient)' : '#333333'}
    />
    {isActive && (
      <defs>
        <linearGradient
          id="gradient"
          x1="0.266235"
          y1="7.89737"
          x2="14.7787"
          y2="6.37278"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FD84BE" />
          <stop offset="0.5" stopColor="#FB7BDB" />
          <stop offset="1" stopColor="#BF78F2" />
        </linearGradient>
      </defs>
    )}
  </svg>
);

export default SendIcon;
